export default {
  'app.setting.pagestyle': 'Configuración del estilo de página',
  'app.setting.pagestyle.dark': 'Estilo oscuro',
  'app.setting.pagestyle.light': 'Estilo claro',
  'app.setting.content-width': 'Ancho del contenido',
  'app.setting.content-width.fixed': 'Fijo',
  'app.setting.content-width.fluid': 'Fluido',
  'app.setting.themecolor': 'Color del tema',
  'app.setting.themecolor.dust': 'Rojo polvo',
  'app.setting.themecolor.volcano': 'Volcán',
  'app.setting.themecolor.sunset': 'Naranja atardecer',
  'app.setting.themecolor.cyan': 'Cian',
  'app.setting.themecolor.green': 'Verde polar',
  'app.setting.themecolor.daybreak': 'Azul amanecer (predeterminado)',
  'app.setting.themecolor.geekblue': 'Azul geek',
  'app.setting.themecolor.purple': 'Púrpura dorado',
  'app.setting.navigationmode': 'Modo de navegación',
  'app.setting.sidemenu': 'Diseño de menú lateral',
  'app.setting.topmenu': 'Diseño de menú superior',
  'app.setting.fixedheader': 'Encabezado fijo',
  'app.setting.fixedsidebar': 'Barra lateral fija',
  'app.setting.fixedsidebar.hint': 'Funciona en el diseño de menú lateral',
  'app.setting.hideheader': 'Ocultar encabezado al desplazar',
  'app.setting.hideheader.hint': 'Funciona cuando el encabezado oculto está habilitado',
  'app.setting.othersettings': 'Otras configuraciones',
  'app.setting.weakmode': 'Modo apto para daltonismo',
  'app.setting.copy': 'Copiar configuración',
  'app.setting.copyinfo':
    'Copia realizada con éxito, reemplaza defaultSettings en src/models/setting.js',
  'app.setting.production.hint':
    'El panel de configuración solo aparece en entorno de desarrollo; por favor, modifica manualmente',
};